export const GET_TOP_PLAYERS = '@get/top_players';

export const getTopPayers = (payload) => ({
  type: GET_TOP_PLAYERS,
  payload,
});
